import React from 'react';
import Hero from '../../components/client/Hero';
import ProductGrid from '../../components/client/ProductGrid';

const Home = () => {
  return (
    <>
      <Hero />
      <ProductGrid />
    </>
  );
};

export default Home;
